// extracted by mini-css-extract-plugin
export var presetSuggestList = "preset-suggest__list_xdHRge6m70NVXs0CYgVS";